import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Typography,
} from '@mui/material';  
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import theme from '../../themes/index.en';
import { CustomDataTableProps } from './customDataTableProps';
import CustomDataTableStyles from '../../assets/css/customDataTable.styles';
import { CustomTableColumnsProps } from './customTableColumnsProps';

const CustomDataTable: React.FC<CustomDataTableProps> = ({
  columns,
  data,
  count,
  rowsPerPageOptions = [5, 10, 25, 100],
  isColored,
  isCompleteColor,
  onPageChange,
  onRowsPerPageChange,
  onSortChange,
  sortBy,
  sortType
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    onPageChange && onPageChange(newPage + 1);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    onRowsPerPageChange && onRowsPerPageChange(event);
    setPage(0);
  };

  return (
    <Paper sx={CustomDataTableStyles.paper}>
      <TableContainer sx={CustomDataTableStyles.tableContainer}>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((column: CustomTableColumnsProps) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  sx={CustomDataTableStyles.tableHeadCell}
                  style={{ cursor: 'pointer' }}
                  onClick={() => onSortChange && onSortChange(column.id)}
                >
                  {column.label}
                  {sortBy === column.id && (
                    sortType === 'asc' ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  <Typography variant="body1">No data available</Typography>
                </TableCell>
              </TableRow>
            ) : (
              data.map((row: any, rowIndex: number) => (
                <TableRow 
                    key={rowIndex} 
                    sx={{ 
                        ...(isColored && row.rowColor ? 
                            { bgcolor: `#${row.rowColor}` } : 
                            (isCompleteColor && !row.isAllDeliveryPointsLinked ? 
                                { bgcolor: `${theme.palette.warning.light}` } : 
                                {}))
                    }}
                > 
                  {columns.map((column: CustomTableColumnsProps) => (
                    <TableCell key={column.id} align={column.align}>
                      {column.renderCell ? column.renderCell({ row }) : row[column.id]}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        sx={CustomDataTableStyles.tablePagination}
      />
    </Paper>
  );
};

export default CustomDataTable;
